import { translation } from './en';

export const publicApp = {
  'common': translation.common,
  'components': translation.components,
  'pages': {
    'nux': {
      'family': {
        'count': {
          'adult': 'Adult',
          'adults': 'Adults',
          'adultsTitle': 'How many adults need care?',
          'alertHeading': 'Please select a birth month to continue',
          'alertDescription': 'Providing a birth month for each child helps us find caregivers with matching experience.',
          'button': 'Confirm',
          'childAge': 'Child {{count}} birth month',
          'child': 'Child',
          'children': 'Children',
          'childrenSubText': 'Ages 0-17',
          'childrenTitle': 'How many kids\u00A0need\u00A0care?',
          'infoCard': {
            'title': 'Find the best fit',
            'description': 'Sharing your child\'s age helps us find caregivers with matching experience.'
          },
          'pet': 'Pet',
          'pets': 'Pets',
          'petsTitle': 'How many pets do you have that need\u00A0care?'
        },
        'location': {
          'title': 'Where are you looking\u00A0for\u00A0care?',
          'city': 'City',
          'state': 'State',
          'neighborhood': 'Neighborhood (optional)',
          'infoCard': {
            'title': 'How we use this info',
            'description': 'Location is used to find nearby, reliable care. Your street address will only ever be shared when you book a caregiver.'
          }
        },
        'petType': {
          'title': 'Who needs care?\n(Select all that apply)',
          'rectangleButtons': {
            'dogs': 'Dog(s)',
            'cats': 'Cat(s)',
            'others': 'Other animal(s)'
          }
        },
        'sitterPreview': {
          'greatNews': 'Great news! There are ',
          'sitterCount': '{{sitterCount}} caregivers ',
          'inYourArea': 'in your area.'
        },
        'vertical': {
          'title': 'First up, what care are you looking\u00A0for\u00A0today?',
          'foundSittersTitle': 'Great news! There are {{sitterCount}} caregivers in your area.',
          'rectangleButtons': {
            'seniorCareSubtitle': 'non-medical',
            'householdServicesSubtitle': 'cleaning, errands, house sitting, etc.'
          },
          'button': 'Let\'s get started!'
        }
      },
    },
  },
  'validation': translation.validation,
}
